import React from "react";
import { Link } from "react-router-dom";
import "./Style.css";

function Sub() {
  return (
    <section className="service-detail">

      {/* 🔥 HERO BANNER */}
        <section className="hero-banner">
          <img src="/service/Substation.png" alt="Substations" />

          <div className="hero-content">
            <h1>SUBSTATIONS</h1>
            {/* <p>Swastika Infra Limited</p>   */}
          </div>
        </section>


      {/* 📄 CONTENT SECTION */}
        <div className="service-detail-content">

          <h2 className="service-heading">SUBSTATIONS</h2>

          <p>
            Swastika has developed the capability to execute high-voltage
            substations including GIS and AIS up to the highest voltage levels.
            Our expertise also includes delivering special substations for
            Railways. The company has a world-class in-house engineering and
            construction team capable of delivering projects across India and
            overseas with precision, safety, and efficiency.
          </p>

         

         

          {/* <h3 className="highlight-title">Key Highlights:</h3>

          <ul className="highlight-list">
            <li>Redevelopment of high-traffic railway stations</li>
            <li>Construction and upgrading of tracks and rail infrastructure</li>
            <li>Integration of advanced technologies for faster execution</li>
            <li>Alignment with modernization and smart mobility goals</li>
          </ul> */}


              <Link to="/service" className="back-btn">
                ← Back 
              </Link> 
        </div>

    </section>
  );
}

export default Sub;
